import { useCallback, useState, useContext } from "react";
import {
  useStore,
  getBezierPath,
  MarkerType,
  Position,
  BaseEdge,
  EdgeLabelRenderer,
  getSmoothStepPath,
  getStraightPath,
} from "reactflow";
import { getEdgeParams } from "./utils.js";
import Tooltip from "@mui/material/Tooltip";
import { ThemeContext } from "../../contexts/themeContext";

function FailureEdge({
  id,
  source,
  target,
  markerEnd,
  sourceX,
  sourceY,
  targetX,
  targetY,
}) {
  const [showTooltip, setShowTooltip] = useState(false);
  const sourceNode = useStore(
    useCallback((store) => store.nodeInternals.get(source), [source])
  );
  const targetNode = useStore(
    useCallback((store) => store.nodeInternals.get(target), [target])
  );
  const { pathType, setPathType } = useContext(ThemeContext);

  if (!sourceNode || !targetNode) {
    return null;
  }

  let [edgePath, labelX, labelY] = [null, null, null];

  switch (pathType) {
    case "smoothstep":
      [edgePath, labelX, labelY] = getSmoothStepPath({
        sourceX,
        sourceY,
        sourcePosition: Position.Bottom,
        targetX,
        targetY,
        targetPosition: Position.Left,
      });
      break;
    case "straight":
      [edgePath, labelX, labelY] = getStraightPath({
        sourceX,
        sourceY,
        sourcePosition: Position.Bottom,
        targetX,
        targetY,
        targetPosition: Position.Left,
      });
      break;
    case "bezier":
      [edgePath, labelX, labelY] = getBezierPath({
        sourceX,
        sourceY,
        sourcePosition: Position.Bottom,
        targetX,
        targetY,
        targetPosition: Position.Left,
      });
      break;
    default:
      break;
    // return null;
  }

  const edgeOptions = {
    style: { strokeWidth: 3, stroke: "#a14e4e" },
    type: {
      type: MarkerType.ArrowClosed,
      color: "#7d3f3f",
    },
  };

  return (
    <>
      <BaseEdge
        id={id}
        className="react-flow__edge-path"
        d={edgePath}
        path={edgePath}
        markerEnd={markerEnd}
        style={edgeOptions.style}
      />
      <EdgeLabelRenderer
        style={{
          pointerEvents: "all",
        }}
      >
        <div
          style={{
            position: "absolute",
            transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
            background: "transparent",
            padding: 10,
            borderRadius: 5,
            fontSize: 12,
            fontWeight: 700,
            pointerEvents: "all",
            color: "transparent",
          }}
          onMouseOver={() => setShowTooltip(true)}
          onMouseOut={() => setShowTooltip(false)}
          className="nodrag nopan"
        >
          {showTooltip && (
            <Tooltip title="Falha na request" placement="top">
              asdsads
            </Tooltip>
          )}
        </div>
      </EdgeLabelRenderer>
    </>
  );
}

export default FailureEdge;
